import { makeObservable, observable, action } from "mobx";

export type Camera = {
    cameraId: string;
    name: string;

    locationId: number;
    rtsp: string;
    isGeneric: boolean;
    rank: number;
};

export type SensorEvent = {
    eventType: string;
    sensorType: string;
    location: string;
    timestamp: string;
};

export class ManageLocationStore {
    public selectedLocationId: number;
    public cameraList: Camera[] = [];
    public sensoreEventList: any[] = [];
    public loadingSensor: boolean = false;
    public loadingCameras: boolean = false;

    constructor() {
        makeObservable(this, {
            cameraList: observable,
            sensoreEventList: observable,
            loadingSensor: observable,
            loadingCameras: observable,

            selectedLocationId: observable,

            setCameraList: action,
            setSensorEventList: action,
        });
    }

    public setSelectedLocationId = (value: number) => {
        this.selectedLocationId = value;
    };

    public getSelectedLocationId = () => {
        return this.selectedLocationId;
    };

    public setCameraList(list: Camera[]) {
        this.cameraList = [...list];
    }

    public setSensorEventList(list: Camera[]) {
        this.sensoreEventList = [...list];
    }
}
